import { Box } from '@chakra-ui/react';
import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  useQueryStates,
} from 'nuqs';
import React, { useTransition } from 'react';

import {
  Consumption,
  DriveTypeList,
  FuelTypeList,
  TransmissionTypeList,
} from '@/services/filters/new-filters.service';

import { MinMaxFilter } from '../min-max-slider/min-max-slider';
import { NewFilter } from '../new-filter/new-filter';
import { useQueryNonce } from '../utils';

import { NewDriveTypeFilter } from './drivetype/new-drive-type-filter';
import { NewFuelTypeFilter } from './fueltype/new-fuel-type-filter';
import styles from './new-more-filters.module.scss';
import { NewTransmissionFilter } from './transmission/new-transmission-filter';

export const NewMoreFilters: React.FC<{
  defaultFuelConsumption: Consumption;
  count: number;
  transmissionTypes?: TransmissionTypeList;
  driveTypes?: DriveTypeList;
  fuelTypes?: FuelTypeList;
  searchQuery?: string; // New prop for search query
  setSearchQuery?: (value: string | null) => void;
}> = ({
  defaultFuelConsumption,
  transmissionTypes,
  driveTypes,
  fuelTypes,
  count,
  searchQuery,
  setSearchQuery,
}) => {
  const [_isPending, startTransition] = useTransition();

  const { generate } = useQueryNonce();

  const [_, setQuery] = useQueryStates(
    {
      fueltype: parseAsArrayOf(parseAsString),
      fueleconomyfrom: parseAsInteger,
      fueleconomyto: parseAsInteger,
      transmission: parseAsArrayOf(parseAsString),
      drivetype: parseAsArrayOf(parseAsString),
    },
    { shallow: false, startTransition },
  );

  return (
    <NewFilter
      label="More Filters"
      placement="bottom-end"
      count={count}
      onClear={() => {
        setQuery(null);
        generate();
        setSearchQuery?.(null);
      }}
    >
      <div className={styles.wrapper}>
        <div className={styles.filtersContainer}>
          <div>
            {fuelTypes && (
              <div className={styles.filterSection}>
                <NewFuelTypeFilter 
                  fuelTypes={fuelTypes} 
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                />
              </div>
            )}
            <div className={styles.filterSection}>
              <Box className={styles.sliderWrapper}>
                <MinMaxFilter
                  min={defaultFuelConsumption.min ?? 0}
                  max={defaultFuelConsumption.max ?? 30}
                  queryKey="fueleconomy"
                  label="Litres/100km"
                />
              </Box>
            </div>
          </div>
          <div>
            {transmissionTypes && transmissionTypes.length > 0 ? (
              <div className={styles.filterSection}>
                <NewTransmissionFilter 
                  transmissionTypes={transmissionTypes} 
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                />
              </div>
            ) : null}
            {driveTypes ? (
              <div className={styles.filterSection}>
                <NewDriveTypeFilter 
                  driveTypes={driveTypes}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </NewFilter>
  );
};
